export const SET_CURRENT_MAP_POSITION = 'SET_CURRENT_MAP_POSITION';

export const setCurrentMapPosition = position => async (dispatch) => {
  dispatch({
    type: SET_CURRENT_MAP_POSITION,
    position,
  });
};



// WEBPACK FOOTER //
// ./src/actions/map.js